import { brandIntro } from '@/mocks/about';

export default function BrandIntro() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
            品牌介绍
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            了解 17c 的品牌故事和发展历程
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <h3 className="text-xl font-semibold text-foreground-950 mb-4">
              我们的使命
            </h3>
            <p className="text-sm text-foreground-700 leading-relaxed mb-6">
              {brandIntro.mission}
            </p>
            <h3 className="text-xl font-semibold text-foreground-950 mb-4">
              我们的愿景
            </h3>
            <p className="text-sm text-foreground-700 leading-relaxed">
              {brandIntro.vision}
            </p>
          </div>
          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20minimal%20open%20office%20workspace%20with%20warm%20lighting%2C%20creative%20team%20collaboration%20environment%2C%20clean%20design%2C%20plants%20and%20wood%20accents%2C%20professional%20atmosphere%2C%20soft%20natural%20light%2C%20inviting%20space&width=600&height=450&seq=about-brand-17c&orientation=landscape"
              alt="17c 办公环境"
              className="w-full rounded-lg object-cover"
            />
          </div>
        </div>

        <div className="mb-16">
          <h3 className="text-xl font-semibold text-foreground-950 mb-8 text-center">
            核心价值观
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {brandIntro.values.map((val) => (
              <div
                key={val.title}
                className="p-6 rounded-lg bg-background-100 border border-background-200/60 text-center"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-4">
                  <i className={`${val.icon} text-xl`}></i>
                </div>
                <h4 className="text-base font-semibold text-foreground-950 mb-2">
                  {val.title}
                </h4>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {val.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-xl font-semibold text-foreground-950 mb-8 text-center">
            发展历程
          </h3>
          <div className="relative">
            <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-background-200 -translate-x-1/2"></div>
            <div className="flex flex-col gap-6">
              {brandIntro.milestones.map((milestone, index) => (
                <div
                  key={milestone.year}
                  className={`flex flex-col md:flex-row items-center gap-4 ${
                    index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                  }`}
                >
                  <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                    <div className="bg-background-100 rounded-lg p-5 border border-background-200/60">
                      <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-primary-100 text-primary-700 mb-2">
                        {milestone.year}
                      </span>
                      <p className="text-sm text-foreground-700">{milestone.event}</p>
                    </div>
                  </div>
                  <div className="hidden md:flex w-4 h-4 rounded-full bg-primary-500 flex-shrink-0 relative z-10"></div>
                  <div className="flex-1 hidden md:block"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}